export default "__VITE_ASSET__fb6cc79d__"